module.exports = __webpack_public_path__ + "static/2020-02_UtahSymphony_creditAustenDiamond_4-2bf7d98bbb5fbf201e29679b021b81b7.jpg";